/**
 * Returns the previous quarter relative to the current date.
 * @returns {Object} An object containing the year and quarter (1-4)
 */
export const getPreviousQuarter = (): { year: number, quarter: number } => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // getMonth() returns 0-11
    const currentQuarter = Math.ceil(currentMonth / 3); // 1-3 months: Q1, 4-6 months: Q2, etc.
    
    // Calculate previous quarter
    let previousQuarter = currentQuarter - 1;
    let previousYear = currentYear;
    
    // If current quarter is Q1, previous quarter is Q4 of previous year
    if (previousQuarter === 0) {
      previousQuarter = 4;
      previousYear = currentYear - 1;
    }
    
    return { year: previousYear, quarter: previousQuarter };
  };
  
  /**
   * Returns the current quarter based on the current date.
   * @returns {number} A number from 1-4 representing the current quarter
   */
  export const getCurrentQuarter = (): number => {
    const month = new Date().getMonth() + 1; // getMonth() returns 0-11
    return Math.ceil(month / 3); // 1-3 months: Q1, 4-6 months: Q2, etc.
  };